import React from "react";
import { Typography } from "@material-ui/core";

const parseTextWithMentions = (
  text: string,
  onMentionClick: (username: string) => void
) => {
  const regex = /@(\w+)/g;
  const parts = [];
  let lastIndex = 0;
  let match: any;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    const username = match[1];
    parts.push(
      <span
        key={match.index}
        style={{ color: "#0095F6", cursor: "pointer" }}
        // eslint-disable-next-line no-loop-func
        onClick={() => {
          onMentionClick(username);
        }}
      >
        {match[0]}
      </span>
    );
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
};

const CommentText: React.FC<{
  text: string;
  onMentionClick: (username: string) => void;
  className?: string;
}> = ({ text, onMentionClick, className }) => {
  return (
    <Typography className={className}>
      {parseTextWithMentions(text, onMentionClick)}
    </Typography>
  );
};
export default CommentText;
